import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { SendToTypeEnum } from '@modules/order/models/send-to-type.enum';
import { ProcedureMap } from '@shared/models/procedure-map';
import { SendToOption } from '@shared/models/send-to-option';

export const getSendToTypesFromOption = (sendToOption: SendToOption | undefined | null): number | undefined | null => {
	return sendToOption ? ('SendToTypes' in sendToOption ? sendToOption.SendToTypes : sendToOption?.Id) : sendToOption;
};

export const getShipToFromOption = (sendToOption: SendToOption | undefined | null): number | undefined | null => {
	return sendToOption ? ('ShipTo' in sendToOption ? sendToOption.ShipTo : sendToOption?.Id) : sendToOption;
};

/**
 * Returns the Custom Rx auto-selection priority for the option, or `null` when none is configured.
 * `null` means "no position provided" (skip from auto-selection), distinct from a real priority of `0`.
 */
export const getAutoSelectionPriority = (sendToOption: SendToOption): number | null =>
	('Settings' in sendToOption ? sendToOption.Settings?.customRxIntegration?.rxAutoSelectionPriority : undefined) ?? null;

/**
 * A lab participates in send-to auto-selection only when its Custom Rx settings define a priority.
 */
export const isAutoSelectableLab = (sendToOption: SendToOption): boolean => {
	const priority = getAutoSelectionPriority(sendToOption);

	return Number.isFinite(priority) && priority !== 0;
};

const knownSendToTypes = new Set<number>(Object.values(SendToTypeEnum) as number[]);

export const isFixedRestorativeRestoLab = (
	procedureMap: ProcedureMap | undefined | null,
	sendTo: SendToOption | undefined | null
): boolean => {
	if (!sendTo || !procedureMap) {
		return false;
	}

	return (
		!!sendTo.Id &&
		sendTo.Id !== SendToTypeEnum.empty &&
		(procedureMap.SendToTypes === SendToTypeEnum.restoLab || !knownSendToTypes.has(procedureMap.SendToTypes)) &&
		procedureMap.ProcedureId === (ProcedureEnum.FixedRestorative as number) &&
		typeof sendTo.Id === 'number'
	);
};
